import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { FileDownloadIndexResponse } from '@/repositories/generated';

const content: FileDownloadIndexResponse[] = [
  {
    downloadFileType: {
      code: 'COMPREHENSIVE_TRANSFER',
      name: '加盟店精算（総合振込）',
    },
    downloadStatus: 'RESERVE',
    id: 1,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '1',
      name: 'ステーション００１',
    },
  },
  {
    downloadFileType: {
      code: 'ACCOUNT_TRANSFER',
      name: '加盟店精算（口座振替）',
    },
    downloadStatus: 'CANCEL',
    id: 2,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '',
      name: '',
    },
  },
  {
    downloadFileType: {
      code: 'SETTLEMENT_VI',
      name: '加盟店精算（イシュア別精算データ）',
    },
    downloadStatus: 'SUCCESS',
    id: 3,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '',
      name: 'ステーション００２',
    },
  },
  {
    downloadFileType: {
      code: 'RECONSILE-FILE-CREATE',
      name: '売上データ還元ファイル',
    },
    downloadStatus: 'PROCESSING',
    id: 4,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '2',
      name: '',
    },
  },
  {
    downloadFileType: {
      code: 'MONTHLY_RECONSILE_FILE_CREATE',
      name: '売上データ還元ファイル（月次）',
    },
    downloadStatus: 'FAILURE',
    id: 5,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '2',
      name: 'ステーション００２',
    },
  },
  {
    downloadFileType: {
      code: 'BANKPAY_RECONCILE',
      name: 'リコンサイル（Bank Pay）',
    },
    downloadStatus: 'RESERVE',
    id: 6,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '1',
      name: 'ステーション００１',
    },
  },
  {
    downloadFileType: {
      code: 'DETECTION',
      name: '不正検知',
    },
    downloadStatus: 'CANCEL',
    id: 7,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '',
      name: '',
    },
  },
  {
    downloadFileType: {
      code: 'APP_USER_CSV',
      name: 'ウォレットユーザ一覧',
    },
    downloadStatus: 'SUCCESS',
    id: 8,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
  },
  {
    downloadFileType: {
      code: 'TRANSACTION_HISTORY_CSV',
      name: '取引履歴一覧',
    },
    downloadStatus: 'PROCESSING',
    id: 9,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
  },
  {
    downloadFileType: {
      code: 'QR_PRINT_REQUEST',
      name: 'QR配送依頼',
    },
    downloadStatus: 'FAILURE',
    id: 10,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '2',
      name: 'ステーション００２',
    },
  },
  {
    downloadFileType: {
      code: 'DGFT_RECONCILE',
      name: 'リコンサイル（DGフィナンシャルテクノロジー）',
    },
    downloadStatus: 'RESERVE',
    id: 11,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '1',
      name: 'ステーション００１',
    },
  },
  {
    downloadFileType: {
      code: 'GMO_RECONCILE',
      name: 'リコンサイル（PSP-GMO）',
    },
    downloadStatus: 'CANCEL',
    id: 12,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
  },
  {
    downloadFileType: {
      code: 'WS_POINT_CHANGE',
      name: 'ポイント付与連携',
    },
    downloadStatus: 'SUCCESS',
    id: 13,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
  },
  {
    downloadFileType: {
      code: 'WS_POINT_CHANGE_UNREGISTERED',
      name: 'ポイント付与連携（管理外店舗）',
    },
    downloadStatus: 'PROCESSING',
    id: 14,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
  },
  {
    downloadFileType: {
      code: 'WS_POINT_CHANGE_ERROR',
      name: 'ポイント付与連携（エラー）',
    },
    downloadStatus: 'FAILURE',
    id: 15,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '2',
      name: 'ステーション００２',
    },
  },
  {
    downloadFileType: {
      code: 'EXPIRY_DATEWISE_BALANCE_DATA',
      name: '有効期限別残高',
    },
    downloadStatus: 'SUCCESS',
    id: 16,
    targetDate: '2023-01-01T00:00:00+09:00',
    updatedAt: '2023-04-23T00:00:00+09:00',
    walletService: {
      id: '1',
      name: 'ステーション００１',
    },
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const fileDownload = http.get(
  createMockEndpoint('/file_download'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const downloadFileTypesExists = url.searchParams.get('downloadFileTypes') ?? '';
    const downloadStatusesExists = url.searchParams.get('downloadStatuses') ?? '';
    const targetDateFromExists = url.searchParams.get('targetDateFrom') ?? '';
    const targetDateToExists = url.searchParams.get('targetDateTo') ?? '';

    if (downloadFileTypesExists || downloadStatusesExists || targetDateFromExists || targetDateToExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
